<app-sidebar>
    <main hlmSidebarInset class="min-w-0 [--app-header-height:3.5rem]">
        <app-header [title]="pageTitle()" />

        <section class="bg-card min-h-[calc(100svh-var(--app-header-height))] min-w-0 flex-1">
            <router-outlet />
        </section>
    </main>
</app-sidebar>
